import i18next from 'i18next';
import React from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';
import { INPULSE_ROLE_NAME } from '@commons/constants/inpulseRole';
import sortActionsList from '@commons/utils/sortActionsList';

export const getActions = ({ displayModalCreateRole, handleExportRoles, disableCreation }) => {
  const actions = [
    {
      id: 'add',
      fixed: true,
      actionLabel: i18next.t('GENERAL.ADD'),
      render: () => (
        <Button
          color={'inpulse-default'}
          handleClick={displayModalCreateRole}
          icon={'/images/inpulse/add-white-small.svg'}
          label={i18next.t('GENERAL.ADD')}
        />
      ),
    },
    {
      id: 'export-roles',
      actionLabel: i18next.t('BACKOFFICE.ROLES.EXPORT_ROLES'),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
      handleAction: handleExportRoles,
    },
  ];

  if (disableCreation) {
    return sortActionsList(actions.filter(({ id }) => id !== 'add'));
  }

  return sortActionsList(actions);
};

const isInpulseRole = (role) => role.name.toLowerCase() === INPULSE_ROLE_NAME;

export const getRowActions = ({
  displayModalEditRole,
  displayModalEditRights,
  displayModalDeleteRole,
  displayModalFeaturesAssociation,
  displayModalFeaturesDissociation,
  displayModalDuplicateRole,
  disableCreation,
  disableDeletion,
  disableUpdate,
}) => {
  const rowActions = [
    {
      id: 'edit-role',
      isDisabled: isInpulseRole,
      isHidden: () => disableUpdate,
      actionLabel: () => i18next.t('BACKOFFICE.ROLES.EDIT'),
      handleAction: (role) => displayModalEditRole(role),
      actionIcon: (role) =>
        isInpulseRole(role)
          ? '/images/inpulse/edit-pen-lmgrey-small.svg'
          : '/images/inpulse/edit-pen-black-small.svg',
    },
    {
      id: 'duplicate-role',
      isDisabled: isInpulseRole,
      isHidden: () => disableCreation,
      actionLabel: () => i18next.t('BACKOFFICE.ROLES.DUPLICATE'),
      handleAction: (role) => displayModalDuplicateRole(role),
      actionIcon: (role) =>
        isInpulseRole(role)
          ? '/images/inpulse/duplicate-lmgrey-small.svg'
          : '/images/inpulse/duplicate-black-small.svg',
    },
    {
      id: 'action-add-features',
      isDisabled: isInpulseRole,
      actionLabel: () => i18next.t('BACKOFFICE.ROLES.ADD_PAGE_ASSOCIATION'),
      handleAction: (role) => {
        displayModalFeaturesAssociation(role);
      },
      actionIcon: (role) =>
        isInpulseRole(role)
          ? '/images/inpulse/icon-plus-lmgrey.svg'
          : '/images/inpulse/icon-plus-ipblack.svg',
    },
    {
      id: 'action-remove-features',
      isDisabled: isInpulseRole,
      actionLabel: () => i18next.t('BACKOFFICE.ROLES.REMOVE_PAGE_ASSOCIATION'),
      handleAction: (role) => displayModalFeaturesDissociation(role),
      actionIcon: (role) =>
        isInpulseRole(role)
          ? '/images/inpulse/icon-minus-lmgrey.svg'
          : '/images/inpulse/icon-minus-ipblack.svg',
    },
    {
      id: 'action-edit-rights',
      isDisabled: (role) => !role.hasFeatureActionsLinked || isInpulseRole(role),
      actionLabel: () => i18next.t('BACKOFFICE.ROLES.EDIT_RIGHTS'),
      handleAction: (role) => displayModalEditRights(role),
      actionIcon: (role) =>
        !role.hasFeatureActionsLinked || isInpulseRole(role)
          ? '/images/inpulse/gear-lmgrey-small.svg'
          : '/images/inpulse/gear-ipblack-small.svg',
      disabledTooltipText: () => i18next.t('BACKOFFICE.TEAM.ROLES_HANDLE_RIGHTS_DISABLED_TOOLTIP'),
    },
    {
      id: 'delete-role',
      isDisabled: (item) => item.name.toLowerCase() === 'inpulse' || item.associatedAccountsCount,
      isHidden: () => disableDeletion,
      actionLabel: () => i18next.t('BACKOFFICE.ROLES.DELETE_ACTION'),
      handleAction: (item) => displayModalDeleteRole(item),
      actionIcon: (item) =>
        item.name.toLowerCase() === 'inpulse' || item.associatedAccountsCount
          ? '/images/inpulse/trash-lmgrey-small.svg'
          : '/images/inpulse/trash-black-small.svg',
    },
  ];

  return rowActions;
};

export default {
  getActions,
  getRowActions,
};
